module.exports = __webpack_public_path__ + "img/给排水.f15a52cf.png";